import { GetByFilterMethodParameter, GetByFilterMethodResponse, TypedDashboard } from 'eurogard-table-system';
import { inject, Injectable, INJECTOR, Injector } from '@angular/core';
import {
  DashboardControllerGetByFilterRemoteMethod,
} from 'open-api-legacy/remote-methods/dashboard-controller-get-by-filter.remote-method';
import { FormType, RXAP_FORM_DEFINITION } from 'eurogard-forms';
import { Method } from 'eurogard-pattern';

@Injectable()
export class LinkDashboardTableMethod
  implements Method<GetByFilterMethodResponse<TypedDashboard>, GetByFilterMethodParameter> {

  private readonly getByFilter        = inject(DashboardControllerGetByFilterRemoteMethod);
  private readonly injector: Injector = inject(INJECTOR);

  async call({parameters}: GetByFilterMethodParameter): Promise<GetByFilterMethodResponse<TypedDashboard>> {

    const formDefinition = this.injector.get<FormType<{ type: number, machineUuid: string }>>(RXAP_FORM_DEFINITION);

    parameters.filter ??= '';
    if (parameters.filter) {
      parameters.filter += '%3B';
    }

    parameters.filter += [
      [ 'dashboardType', formDefinition.type?.value ?? 0 ].join('%3A'),
      [ 'link', 'orgId' ].join('%3A'),
    ].join('%3B');

    if (formDefinition.machineUuid?.value) {
      parameters.filter += '%3B' + ['machineUuid', formDefinition.machineUuid?.value ?? 0 ].join('%3A');
    }

    const response = await this.getByFilter.call({parameters});
    return {
      ...response,
      entities: response.entities?.map(dashboard => ({
        ...dashboard,
        companyName: dashboard.company?.name ?? null,
        locationName: dashboard.location?.name ?? null,
      })) ?? [],
    };
  }

}
